/**
 * 获取装饰器类型
 * @public
 */
function getDecoratorType(args) {
    const [, propertyKey, descriptor] = args;
    if (typeof descriptor === 'number') {
        return 'parameter';
    }
    if ((propertyKey && descriptor === undefined)
        || (descriptor && (descriptor.get || descriptor.set))) {
        return 'property';
    }
    return (descriptor === null || descriptor === void 0 ? void 0 : descriptor.value) ? 'method' : 'class';
}

export { getDecoratorType };
//# sourceMappingURL=ts-utils.js.map
